import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-8" }
const _hoisted_2 = { class: "col-xl-4" }
const _hoisted_3 = { class: "col-xl-4" }
const _hoisted_4 = { class: "col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Chart, {
        "widget-classes": "card-xl-stretch mb-xl-8",
        "widget-color": "info",
        "chart-height": "200"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Chart, {
        "widget-classes": "card-xl-stretch mb-xl-8",
        "widget-color": "danger",
        "chart-height": "200"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Chart, {
        "widget-classes": "card-xl-stretch mb-xl-8",
        "widget-color": "info",
        "chart-height": "200"
      })
    ])
  ]))
}